import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, isRef as _isRef, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import {PropType} from "vue";
import {VATabsCascadeOptions} from "./typings";
import VASelect from "../VASelect/VASelect";
import VATabs from "../VATabs/VATabs";
import {useTabsCascadeHandler} from "./hooks";


export default /*@__PURE__*/_defineComponent({
  __name: 'VATabsCascade',
  props: {
  value: {
    type: [String, Number, Boolean]
  },
  options: {
    type: Object as PropType<VATabsCascadeOptions>,
    default: () =>{
      return {}
    }
  }
},
  emits: ['update:value', 'on-change'],
  setup(__props, { emit: __emit }) {

const emit = __emit

const props = __props

const {parentValue, child, childRef, changeParent} = useTabsCascadeHandler(props.options as VATabsCascadeOptions, emit)

const change = (value: any) => {
  emit("update:value", value)
  emit("on-change", value)
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(VATabs), {
      value: _unref(parentValue),
      "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => (_isRef(parentValue) ? (parentValue).value = $event : null)),
      options: __props.options,
      onOnChange: _unref(changeParent)
    }, null, 8, ["value", "options", "onOnChange"]),
    _createVNode(_unref(VASelect), {
      ref_key: "childRef",
      ref: childRef,
      options: _unref(child),
      placeholder: _unref(child).placeholder,
      value: __props.value,
      width: _unref(child).width,
      onOnChange: change,
      size: _unref(child).size
    }, null, 8, ["options", "placeholder", "value", "width", "size"])
  ], 64))
}
}

})